import { render, staticRenderFns } from "./Connells.vue?vue&type=template&id=37a88876&"
import script from "./Connells.vue?vue&type=script&lang=js&"
export * from "./Connells.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports